<template>
  <Hero
      v-if="heroMediaId"
      height="small"
      font-color="white"
      background-position-x="center"
      background-position-y="center"
      :media-id="heroMediaId"
      :key="`priceshow-hero-${heroMediaId}`"
  >
    <template #headline>Dein persönliches Angebot</template>
  </Hero>
  <PriceshowCategorySection
    v-for="(branch, inx) in activeBranches"
    :key="`priceshow-section--${branch.slug}`"
    :branch="branch"
    v-model="activeBranchParams[branch.slug]"
    :section-props="{
      background: branch.mainCategory.key,
      wave: inx === 0 ? 'double-wave' : 'wave',
      waveNegative: true,
      paddingTop: false,
    }"
  />
</template>

<script lang="ts" setup>
import Hero from '@/components/Hero.vue';
import PriceshowCategorySection from '@/components/priceshow/PriceshowCategorySection.vue';
import BranchInterface from '@/interfaces/BranchInterface';
import PriceshowParamsInterface from '@/interfaces/PriceshowParamsInterface';
import {
  reactive,
  computed, watch, ref,
} from 'vue';
import {
  useStore,
} from 'vuex';
import {
  useRoute,
} from 'vue-router';

const route = useRoute();
const store = useStore();

const activeBranchSlugs = reactive<string[]>([
  route.params.branch as string,
]);

// const remainingBranches = computed(() => store.getters['branches/all'].filter((branch: BranchInterface) => !activeBranchSlugs.includes(branch.slug || '')));
const activeBranches = computed(() => store.getters['branches/all'].filter((branch: BranchInterface) => activeBranchSlugs.includes(branch.slug || '')));

const activeBranchParams = reactive<Record<string, PriceshowParamsInterface>>({
  [route.params.branch as string]: {
    branch: route.params.branch as string,
    productId: route.query.pid ? parseInt(route.query.pid as string, 10) : undefined,
    customerType: `${route.query.gewerbe}` === '1' ? 'business' : 'private',
    isCustomer: `${route.query.energiekunde}` === '1',
    double: !!route.params.usageHt,
    usage: parseInt(`${route.params.usage || 0}`, 10),
    usageHt: parseInt(`${route.params.usageHt || 0}`, 10),
    postcode: route.params.postcode as string,
    city: route.query.stadt as string,
    street: route.query.strasse as string,
    houseNumber: route.query.hausnummer as string,
  },
});

const heroMediaId = ref<number | `${number}`>();

const setHeroMediaId = () => {
  const firstBranch = activeBranches.value[0];

  if (!firstBranch) return;

  const priceshowMedia = firstBranch.media.priceshow;

  if (!priceshowMedia) return;

  heroMediaId.value = priceshowMedia;
};

watch(() => activeBranches.value[0], setHeroMediaId, {
  immediate: true,
  deep: true,
});
</script>

<style lang="scss">
@import 'src/scss/component-helpers';

.priceshow {
  background-color: #F7F7F7;
  z-index: 2;
  position: relative;

  .col-search {
    @include responsive-size-sm(24);

    > div {
      position: sticky;
      position: -webkit-sticky;
      top: 0;
      margin-top: -1.66667em;
    }

    &__sticky {
      padding-top: 1.66667em;
      padding-bottom: 1.66667em;
    }
  }

  &__container {
    > div:first-child {
      &:before, &:after {
        @include font-h2;
        content: '';
        display: block;
        height: 2.27273em;
      }
    }
  }

  h1 {
    color: #000000;
    @include font-h2;
    margin-bottom: 1.15em;
  }

  .text-saving {
    @include font-small;
    font-weight: 400;
    color: #38383A;
  }
}
</style>
